/**
 * The sign-off reason is the signer's own words and the Methodology reason is
 * the one typed on Methodology — two fields, never one copied into the other.
 * Finalize sends only the sign-off reason; the Methodology reason stays on the
 * saved draft.
 */

/** Same reason = equal after trimming the ends, ignoring case. A blank side is never "the same". */
export function sameReason(a: string, b: string): boolean {
  const x = a.trim().toLowerCase()
  return x.length > 0 && x === b.trim().toLowerCase()
}
